import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

@Component({
	selector: 'kt-inauguration-screen',
	templateUrl: './inauguration-screen.component.html',
	styleUrls: ['./inauguration-screen.component.scss']
})
export class InaugurationScreenComponent implements OnInit {
	timeLeft: number = 5;
	interval;
	showCounter: boolean = false;

	constructor(private cdr: ChangeDetectorRef,) { }

	ngOnInit() {
	}

	startTimer() {
		this.showCounter = true;
		this.interval = setInterval(() => {
			if (this.timeLeft > 0) {
				this.timeLeft--;
				this.cdr.detectChanges();
			} else {
				this.cdr.detectChanges();
				window.location.href = ('https://www.hec.gov.pk/english/scholarshipsgrants/IDPS/Pages/default.aspx');
			}
		}, 1000)
	}
}
